import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Alert, Chip, CircularProgress, Snackbar, Stack } from '@mui/material';
import { db } from '../../lib/firebase';
import { doc, updateDoc } from "firebase/firestore";
import { useTranslation } from 'react-i18next';
import NewTagModal from './NewTagModal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function EditOutfit({ openEditOutfitModal, setOpenEditOutfitModal, userTags, currentOutfitTags, userId, outfitId }) {
  const [updatedTagList, setUpdatedTagList] = useState(currentOutfitTags);
  const [editOutfitError, setEditOutfitError] = useState(null)
  const [momentCreatedMessage, setMomentCreatedMessage] = useState(null);
  const { t } = useTranslation();

  const handleClose = () => {
    setOpenEditOutfitModal(false)
    setEditOutfitError(null)
  };

  const handleNewSelectedTag = (tagId) => {
    if (updatedTagList.includes(tagId)) {
      setUpdatedTagList(updatedTagList.filter(t => t !== tagId))
    } else {
      setUpdatedTagList([...updatedTagList, tagId])
    }
  }

  const handleSaveNewTagListOutfit = async () => {
    try {
      await updateDoc(doc(db, 'users', userId, 'outfits', outfitId), {
        moments: updatedTagList,
      });
      handleClose()
      setEditOutfitError(null)
    } catch (error) {
      setEditOutfitError(true)
    }
  }

  const handleCloseSnackbarMoment = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setMomentCreatedMessage(null);
  };


  if (userTags == null) {
    return <><CircularProgress /></>
  }



  return (
    <div>
      <Modal
        open={openEditOutfitModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {t("editOutfit.title")}
          </Typography>
          <Box id="modal-modal-description" sx={{ mt: 2, mb: '8px' }}>
            {userTags.map((tag) => (
              <Chip
                label={tag.name} sx={{ mb: 1 }}
                key={tag.id} onClick={() => handleNewSelectedTag(tag.id)}
                color={updatedTagList.includes(tag.id) ? "primary" : "default"}
              />
            ))}
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <NewTagModal userId={userId} setMomentCreatedMessage={setMomentCreatedMessage} onTagCreated={(tagId) => {handleNewSelectedTag(tagId)}}/>
            </Box>
          </Box>
          <Stack spacing={2} sx={{ width: '100%', marginTop: 1 }}>
            <Snackbar open={momentCreatedMessage != null} autoHideDuration={6000} onClose={handleCloseSnackbarMoment} sx={{ width: '100%' }}>
              <Alert onClose={handleCloseSnackbarMoment} severity="success">
                {t('newOutfit.momentCreated')} {momentCreatedMessage}
              </Alert>
            </Snackbar>
          </Stack>
          <Button variant="contained" sx={{ width: "100%" }} onClick={handleSaveNewTagListOutfit}>{t('save')}</Button>
          {editOutfitError != null &&
            <Alert severity="error" sx={{ mt: 2 }}>{t("editOutfit.error")}</Alert>
          }
        </Box>
      </Modal>
    </div>
  );
}
